import { useState } from "react";
import HeroHome from "./hero-home";
import FeaturesBlock from "../../components/features-block";
import Target from "../../components/target";
import HomeForm from "../../components/form/home";
import useHomeFormSubmit from "../../hooks/useHomeFormSubmit";
import SuccessMessage from "../../components/success-message";
import { HomeFormProvider } from "../../components/form/home/context";

const Home = () => {
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const { methods, handleSubmit } = useHomeFormSubmit({
    setOnSuccess: setShowSuccessMessage,
  });

  return (
    <HomeFormProvider>
      <HeroHome>
        {showSuccessMessage ? (
          <SuccessMessage message={"We'll be in touch soon :)"} />
        ) : (
          <HomeForm methods={methods} handleSubmit={handleSubmit} />
        )}
      </HeroHome>
      <FeaturesBlock />
      <Target />
    </HomeFormProvider>
  );
};

export default Home;
